import { gql } from "@apollo/client";

export const UPDATE_PLAN_CUIDADO_COMPLETE = gql`
    mutation updatePlanCuidadoComplete(
        $datosGenerales: EditPlanCuidadoDatosGralesInput!,
        $delegaciones: [EditPlanCuidadoDelegacionInput!]!,
        $clientes: [EditPlanCuidadoClienteInput!]!,
        $documentoLegales: EditPlanCuidadoDocumentoLegalInput,
        $documentoFacturaciones: [EditPlanCuidadoDocumentoFacInput!]!,
        $insumos: [EditPlanCuidadoInsumoInput!]!,
        $dietas: [EditPlanCuidadoDietaInput!]!,
        $fases: [EditPlanCuidadoFaseInput!]!,
        $profesionales: [EditPlanCuidadoFaseProfesionalInput!]!,
        $newInsumos: Boolean!
         ){
        updatePlanCuidadoComplete(
            input: {
                datosGenerales: $datosGenerales,
                delegaciones: $delegaciones,
                clientes: $clientes,
                documentoLegales: $documentoLegales,
                documentoFacturaciones: $documentoFacturaciones,
                insumos: $insumos,
                dietas: $dietas,
                fases: $fases,
                profesionales: $profesionales,
                newInsumos: $newInsumos 
            }
        ) {
            idPlanCuidado
        }
    }
`;